import React, { CSSProperties, useMemo } from "react";
import ColorHash from "color-hash";
import tinycolor from "tinycolor2";


// Sample Colors
// #AADDD5	H: 171°, S: 43%, L: 77%
// #E9F6F4	H: 171°, S: 42%, L: 94%
// #D1ECE7	H: 169°, S: 42%, L: 87%

const colorHasher = new ColorHash({
    hue: { min: 169, max: 171 },
    lightness: [0.75, 0.8, 0.85, 0.9, 0.95],
    saturation: [0.4, 0.42, 0.45]
});

interface TextBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
    text: string;
}

const TextBadge: React.FC<TextBadgeProps> = (props) => {
    const { text, className: propsClassName, style: propsStyle, ...restProps } = props;

    const hashedBadgeStyle = useMemo(() => {
        const bgColor = colorHasher.hex(text);
        const style: CSSProperties = { backgroundColor: bgColor };
        if (tinycolor(bgColor).isDark()) {
            style.color = "#ffffff";
        }
        return style;
    }, [text]);

    if (!text) {
        return <div className={propsClassName} {...restProps} />;
    }
    return (
        <div className={propsClassName}
             style={{ ...propsStyle, ...hashedBadgeStyle }}
             {...restProps}
        >
            {text}
        </div>
    );
};

export default TextBadge;
